(function () {
  function applyCompareLayout(dialogRoot) {
    const table = dialogRoot.querySelector('sc-comparison-table');
    if (!table) return;

    const products = Array.from(table.querySelectorAll('.product'));
    let visibleCount = products.filter((prod) => {
      const style = window.getComputedStyle(prod);
      return prod.offsetParent !== null && style.display !== 'none' && style.visibility !== 'hidden';
    }).length;

    let count = visibleCount || products.length;

    if (!count) {
      try {
        const host = dialogRoot.host;
        if (host) {
          const styles = getComputedStyle(host);
          const varValue = styles.getPropertyValue('--compared-products-count');
          if (varValue) {
            count = parseInt(varValue.trim(), 10);
          }
        }
      } catch (e) {}
    }

    let classSuffix = count;
    if (count >= 4) classSuffix = '4plus';

    table.classList.remove(
      'compare-has-1',
      'compare-has-2',
      'compare-has-3',
      'compare-has-4plus'
    );
    table.classList.add(`compare-has-${classSuffix}`);

    requestAnimationFrame(() => syncCompareImageSizes(dialogRoot));
  }

  function syncCompareImageSizes(dialogRoot) {
    const images = dialogRoot.querySelectorAll('img.product__image');
    images.forEach((img) => {
      const wrapper = img.closest('.product__image-wrapper');
      const target = wrapper || img;
      const width = Math.ceil(target.getBoundingClientRect().width);
      if (!width) return;
      const dpr = window.devicePixelRatio || 1;
      const scale = Math.min(4, Math.max(3, dpr));
      const targetWidth = Math.min(3600, Math.ceil(width * scale));
      const boostedWidth = Math.max(3600, targetWidth);
      const sizeValue = `${boostedWidth}px`;
      if (img.getAttribute('sizes') !== sizeValue) {
        img.setAttribute('sizes', sizeValue);
      }
    });
  }

  function injectCompareStyles() {
    const dialogs = document.querySelectorAll('sc-dynamic-compare-dialog');

    dialogs.forEach((dialog) => {
      const root = dialog.shadowRoot;
      if (!root) return;
      if (!root._compareLayoutObserver) {
        root._compareLayoutObserver = new MutationObserver(() => applyCompareLayout(root));
        root._compareLayoutObserver.observe(root, { childList: true, subtree: true });
      }

      let style = root.querySelector('style[data-custom-compare="true"]');
      if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-custom-compare', 'true');

        style.textContent = `
        sc-floating-compare-button.floating-compare-button--horizontal {
          left: 0 !important;
        }
        sc-floating-compare-button .floating-compare-button__button { 
          margin-left: 195px !important;
          width: 184px !important;
          height: 50px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          text-transform: uppercase !important;
          font-weight: 800 !important;
        }
          .compare-dialog__content {
            padding-top: 4px !important;
            padding-inline: min(32px, 4vw) !important;
          }

          .table-container {
            margin-top: 0 !important;
            padding-top: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            overflow-x: auto !important;
            overscroll-behavior-x: contain !important;
          }

          .comparison-table {
            width: max-content !important;
            min-width: 100% !important;
            table-layout: auto !important;
            border-collapse: separate !important;
            border-spacing: 12px 0 !important;
          }

          .comparison-table .row:not(.row--product) th,
          .comparison-table .row:not(.row--product) td {
            white-space: normal !important;
            word-break: break-word !important;
          }
          .comparison-table .row:not(.row--product) .attribute-value,
          .comparison-table .row:not(.row--product) .attribute-name,
          .comparison-table .row:not(.row--product) .group-name {
            white-space: normal !important;
            word-break: break-word !important;
            hyphens: auto !important;
          }

          .comparison-table .row-group--head .row--product .column-header {
            padding-top: 4px !important;
            padding-bottom: 8px !important;
          }

          .comparison-table .row-group--body .cell {
            width: 360px !important;
            max-width: 360px !important;
            vertical-align: top !important;
          }

          .comparison-table .row--product th.column-header:not(.sticky-column) {
            width: 360px !important;
            max-width: 360px !important;
            padding-inline: 8px !important;
          }
          .comparison-table .row--product.compare-has-3 th.column-header:not(.sticky-column),
          sc-comparison-table.compare-has-3 .row--product th.column-header:not(.sticky-column) {
            width: min(300px, 28vw) !important;
            max-width: min(300px, 28vw) !important;
          }
          .comparison-table .row--product.compare-has-4plus th.column-header:not(.sticky-column),
          sc-comparison-table.compare-has-4plus .row--product th.column-header:not(.sticky-column) {
            width: min(260px, 24vw) !important;
            max-width: min(260px, 24vw) !important;
          }
          .comparison-table.compare-has-3 .row-group--body .cell,
          sc-comparison-table.compare-has-3 .row-group--body .cell {
            width: min(300px, 28vw) !important;
            max-width: min(300px, 28vw) !important;
          }
          .comparison-table.compare-has-4plus .row-group--body .cell,
          sc-comparison-table.compare-has-4plus .row-group--body .cell {
            width: min(260px, 24vw) !important;
            max-width: min(260px, 24vw) !important;
          }

          sc-comparison-table .product {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            min-width: 100% !important;
            margin-inline: auto !important;
            padding-top: 0 !important;
            text-align: left !important;
          }

          sc-comparison-table .product .relative {
            position: relative !important;
            width: 100%;
          }

          /* Default */
          sc-comparison-table .product__image-wrapper {
            display: block !important;
            margin: 0px !important;
            width: 100% !important;
            height: auto !important;
            max-width: 100% !important;
            aspect-ratio: 830 / 1245 !important;
            overflow: hidden !important;
            max-height: 75vh !important;
          }

          /* 1–2 productos: más grandes */
          sc-comparison-table.compare-has-1 .product__image-wrapper,
          sc-comparison-table.compare-has-2 .product__image-wrapper {
            max-width: 360px !important;
          }

          /* 3 productos: tamaño medio */
          sc-comparison-table.compare-has-3 .product__image-wrapper {
            max-width: min(320px, 24vw) !important;
          }

          /* 4 o más productos: más pequeños */
          sc-comparison-table.compare-has-4plus .product__image-wrapper {
            max-width: min(260px, 21vw) !important;
          }

          sc-comparison-table img.product__image {
            width: 100% !important;
            height: 100% !important;
            object-fit: cover !important;
            border-radius: 0 !important;
            display: block !important;
          }

          @media (max-width: 768px) {
            .comparison-table {
              border-spacing: 0 !important;
              width: 100% !important;
              min-width: 100% !important;
            }
            .comparison-table .row--product th.column-header:not(.sticky-column),
            .comparison-table .row-group--body .cell,
            .comparison-table.compare-has-3 .row--product th.column-header:not(.sticky-column),
            .comparison-table.compare-has-3 .row-group--body .cell,
            .comparison-table.compare-has-4plus .row--product th.column-header:not(.sticky-column),
            .comparison-table.compare-has-4plus .row-group--body .cell {
              width: auto !important;
              max-width: 100% !important;
              padding-inline: 6px !important;
            }
            sc-comparison-table .product__image-wrapper {
              max-width: 100% !important;
            }
            .comparison-table .row-header.sticky-column {
              width: auto !important;
              max-width: 100% !important;
              padding-inline: 6px !important;
              white-space: normal !important;
            }
          }

          sc-comparison-table .product__remove-button {
            position: absolute !important;
            top: 8px !important;
            right: 8px !important;
            width: 28px !important;
            height: 28px !important;
            padding: 0 !important;
            border: none !important;
            border-radius: 999px !important;
            background: #ffffff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            cursor: pointer !important;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25) !important;
          }

          sc-comparison-table.compare-has-1 .product__remove-button,
          sc-comparison-table.compare-has-2 .product__remove-button {
            display: none !important;
          }

          sc-comparison-table .product__remove-button svg {
            display: none !important;
          }

          sc-comparison-table .product__remove-button::before,
          sc-comparison-table .product__remove-button::after {
            content: "" !important;
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            width: 12px !important;
            height: 2px !important;
            background: #777777 !important;
            border-radius: 1px !important;
            transform-origin: center !important;
          }

          sc-comparison-table .product__remove-button::before {
            transform: translate(-50%, -50%) rotate(45deg) !important;
          }

          sc-comparison-table .product__remove-button::after {
            transform: translate(-50%, -50%) rotate(-45deg) !important;
          }

          sc-comparison-table .product__info {
            margin-top: 0 !important;
            width: 100% !important;
            text-align: left !important;
          }

          sc-comparison-table .product__title {
            display: block !important;
            font-size: clamp(14px, 1.7vw, 18px) !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
            margin-bottom: 2px !important;
          }

          sc-comparison-table .product__price {
            display: block !important;
            font-size: clamp(14px, 1.5vw, 16px) !important;
            font-weight: 500 !important;
            margin-bottom: 8px !important;
          }

          sc-comparison-table .product .rating-badge {
            display: none !important;
          }

          sc-comparison-table .product a.button[part="button"] {
            display: none !important;
          }

          @media (max-width: 1000px) {
            .compare-dialog__content {
              padding-inline: 16px !important;
            }

            sc-comparison-table .product__image-wrapper {
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              aspect-ratio: 830 / 1245 !important;
              max-height: 60vh !important;
            }

            sc-comparison-table img.product__image {
              width: 100% !important;
              height: 100% !important;
              object-fit: cover !important;
            }
          }
        `;

        root.appendChild(style);

        root.addEventListener(
          'click',
          (event) => {
            const target = event.target;
            if (target && target.closest && target.closest('.product__remove-button')) {
              setTimeout(() => applyCompareLayout(root), 50);
            }
          },
          true
        );
      }

      applyCompareLayout(root);
    });
  }

  injectCompareStyles();

  const observer = new MutationObserver(injectCompareStyles);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener(
    'resize',
    () => {
      document.querySelectorAll('sc-dynamic-compare-dialog').forEach((dialog) => {
        const root = dialog.shadowRoot;
        if (!root) return;
        syncCompareImageSizes(root);
      });
    },
    { passive: true }
  );
})();

(function () {
  function injectCompareCardStyles() {
    if (document.head.querySelector('style[data-compare-card="true"]')) return;

    const style = document.createElement('style');
    style.setAttribute('data-compare-card', 'true');
    style.textContent = `
      sc-add-to-compare {
        display: block !important;
        margin: 4px 0 0 0 !important;
        text-align: left !important;
      }

      sc-add-to-compare::part(checkbox-control) {
        display: inline-flex !important;
        align-items: center !important;
        gap: 6px !important;
        font-size: 13px !important;
        line-height: 1.2 !important;
      }

      sc-add-to-compare::part(checkbox-input) {
        -webkit-appearance: none !important;
        appearance: none !important;
        width: 16px !important;
        height: 16px !important;
        border-radius: 2px !important;
        border: 1px solid #000000 !important;
        background: #ffffff !important;
        position: relative !important;
        cursor: pointer !important;
        padding: 0 !important;
        box-sizing: border-box !important;
      }

      sc-add-to-compare::part(checkbox-input)::before {
        content: "" !important;
        position: absolute !important;
        left: 3px !important;
        top: 0px !important;
        width: 5px !important;
        height: 9px !important;
        border-right: 2px solid #666666 !important;
        border-bottom: 2px solid #666666 !important;
        transform: rotate(40deg) !important;
        opacity: 0 !important;
      }

      sc-add-to-compare::part(checkbox-input):checked::before {
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  }

  function fixComparePerCard() {
    const cards = document.querySelectorAll('.custom-product-card__content a.sizelist-wrap');

    cards.forEach((card) => {
      const compares = card.querySelectorAll('sc-add-to-compare');
      if (!compares.length) return;

      const metas = card.querySelectorAll('.grid-product__meta.custom-price-wrap');
      const prices = card.querySelectorAll('.grid-product__price-wrap.custom-price-wrap');
      if (!metas.length || !prices.length) return;

      const activeMeta =
        card.querySelector('.grid-product__meta.custom-price-wrap.active') || metas[0];

      const metasArr = Array.from(metas);
      const activeIndex = metasArr.indexOf(activeMeta);
      if (activeIndex === -1) return;

      const activePrice = prices[activeIndex] || prices[0];

      const mainCompare = compares[0];

      compares.forEach((comp) => {
        if (comp !== mainCompare) {
          comp.remove();
        }
      });

      if (!activePrice || !activePrice.parentNode) return;

      const parent = activePrice.parentNode;
      if (mainCompare.previousElementSibling === activePrice && mainCompare.parentNode === parent) {
        return;
      }

      parent.insertBefore(mainCompare, activePrice.nextSibling);
    });
  }

  injectCompareCardStyles();
  fixComparePerCard();

  const observer = new MutationObserver(fixComparePerCard);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();

(function () {
  function injectFloatingStyles() {
    const blocks = document.querySelectorAll('sc-dynamic-compare');

    blocks.forEach((block) => {
      const root = block.shadowRoot;
      if (!root) return;

      if (root.querySelector('style[data-custom-floating="true"]')) return;

      const style = document.createElement('style');
      style.setAttribute('data-custom-floating', 'true');

      style.textContent = `
        :host {
          --floating-compare-button-inset-inline: 10% auto !important;
          --floating-compare-button-justify-content: flex-start !important;
        }

        sc-floating-compare-button.floating-compare-button--horizontal {
          left: 0 !important;
        }

        sc-floating-compare-button .floating-compare-button__button {
          margin-left: 0 !important;
          width: 184px !important;
          height: 50px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          text-transform: uppercase !important;
          font-weight: 600 !important;
        }

        :host([data-kl-teaser-visible]) sc-floating-compare-button .floating-compare-button__button {
          margin-left: 195px !important;
          width: 184px !important;
          height: 50px !important;
        }

        @media (max-width: 768px) {
          :host {
            --floating-compare-button-inset-inline: 0 auto !important;
            --floating-compare-button-justify-content: flex-start !important;
          }

          sc-floating-compare-button.floating-compare-button--horizontal {
            left: 0 !important;
            transform: none !important;
            right: auto !important;
            bottom: 0 !important;
          }

          sc-floating-compare-button .floating-compare-button__button {
            margin-left: 0 !important;
            width: 150px !important;
            height: 50px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            text-transform: uppercase !important;
            font-weight: 800 !important;
          }

          :host([data-kl-teaser-visible]) sc-floating-compare-button.floating-compare-button--horizontal {
            left: 150px !important;
            transform: none !important;
            right: auto !important;
            bottom: 0 !important;
            top: auto !important;
          }

          :host([data-kl-teaser-visible]) sc-floating-compare-button .floating-compare-button__button {
            margin-left: 0 !important;
            width: 150px !important;
            height: 50px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            text-transform: uppercase !important;
            font-weight: 800 !important;
          }
        }
      `;

      root.appendChild(style);
    });
  }

  let floatingSyncTimeout = null;

  function requestSyncKlaviyoFloatingOffset() {
    if (floatingSyncTimeout) {
      clearTimeout(floatingSyncTimeout);
    }
    floatingSyncTimeout = setTimeout(syncKlaviyoFloatingOffset, 250);
  }

  function getVisibleKlaviyoTeaserRect() {
    const teasers = document.querySelectorAll('[class*="kl-teaser-"]');
    for (let i = 0; i < teasers.length; i += 1) {
      const teaser = teasers[i];
      const rect = teaser.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) continue;

      const styles = window.getComputedStyle(teaser);
      if (styles.display === 'none' || styles.visibility === 'hidden' || parseFloat(styles.opacity) === 0) {
        continue;
      }

      return rect;
    }

    return null;
  }

  function syncKlaviyoFloatingOffset() {
    const teaserRect = getVisibleKlaviyoTeaserRect();
    const blocks = document.querySelectorAll('sc-dynamic-compare');

    blocks.forEach((block) => {
      if (teaserRect) {
        block.setAttribute('data-kl-teaser-visible', 'true');
        const offset = Math.max(0, Math.round(teaserRect.left + teaserRect.width + 8));
        block.style.setProperty('--kl-teaser-offset', `${offset}px`);
      } else {
        block.removeAttribute('data-kl-teaser-visible');
        block.style.removeProperty('--kl-teaser-offset');
      }
    });
  }

  function handleFloatingSetup() {
    injectFloatingStyles();
    requestSyncKlaviyoFloatingOffset();
  }

  handleFloatingSetup();

  const observer = new MutationObserver(handleFloatingSetup);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  window.addEventListener('resize', requestSyncKlaviyoFloatingOffset, { passive: true });
  window.addEventListener('orientationchange', requestSyncKlaviyoFloatingOffset, { passive: true });
})();

(function () {
  function injectKlaviyoTeaserTweaks() {
    if (document.head.querySelector('style[data-kl-teaser-tweaks="true"]')) return;

    const style = document.createElement('style');
    style.setAttribute('data-kl-teaser-tweaks', 'true');
    style.textContent = `
      @media (max-width: 768px) {
        div[class*="kl-teaser-"] {
          width: min(150px, 45vw) !important;
          margin: 0 8px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  injectKlaviyoTeaserTweaks();
})();
